'use client';

import { useEffect, useState } from 'react';
import { unwrapResultSuccess } from '@headless-workspace/core-domain';
import { getDeliveryStoreCookieServerAction } from '@headless-workspace/domain/common/server';

export const useDeliveryStoreCookie = (highlightedStoreId: string | undefined) => {
    const [storeId, setStoreId] = useState<string>();

    useEffect(() => {
        async function fetchData() {
            const data = await getDeliveryStoreCookieServerAction();
            if (data.type === 'success') {
                const result = unwrapResultSuccess(data);
                setStoreId(result);
            }
        }
        if (!highlightedStoreId) {
            fetchData();
        }
    });

    return {
        storeId,
    };
};
